(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cg-cgrid-gallery-js"] && !Shopify.designMode) return;
  try {
    // Detail: docs/comments/snippets/cg-cgrid-gallery-js.md#variant-gallery-for-cg-collection-grid-cards

  // Detail: docs/comments/snippets/cg-cgrid-gallery-js.md#one-mediaquerylist-per-page-not-per-instance
  const hoverQuery = window.matchMedia('(hover: hover)');
  const reducedQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  // Detail: docs/comments/snippets/cg-cgrid-gallery-js.md#shared-read-then-write-scheduler-for-the-thumb-strip-paddle-state
  const pendingNav = new Set();
  let navFrame = 0;

  const flushNav = () => {
    navFrame = 0;
    const batch = [...pendingNav];
    pendingNav.clear();

    // Read pass: no writes in this loop, or the next read re-lays out.
    const measured = [];
    for (const nav of batch) {
      const { track } = nav;
      if (!track.isConnected) continue;
      measured.push({
        nav,
        max: Math.max(track.scrollWidth - track.clientWidth, 0),
        left: track.scrollLeft,
      });
    }

    // Write pass: skip no-op writes so a steady-state scroll invalidates nothing.
    for (const { nav, max, left } of measured) {
      const overflowing = max > 1;
      if (overflowing !== nav.overflowing) {
        nav.overflowing = overflowing;
        nav.strip.toggleAttribute('data-overflowing', overflowing);
      }
      const atStart = left <= 1;
      const atEnd = left >= max - 1;
      if (nav.prev.disabled !== atStart) nav.prev.disabled = atStart;
      if (nav.next.disabled !== atEnd) nav.next.disabled = atEnd;
    }
  };

  const scheduleNav = (nav) => {
    pendingNav.add(nav);
    if (navFrame) return;
    navFrame = requestAnimationFrame(flushNav);
  };

  class CgCgridGallery extends HTMLElement {
    #abort = null;
    #token = 0;
    #img = null;
    #lead = null;
    #want = '';
    #resize = null;
    #cardLink = null;
    #leadHref = '';
    #transitionSource = null;
    #nav = null;

    connectedCallback() {
      if (this.#abort) return;
      const img = this.querySelector('img.cg-cgrid__media-img');
      if (!img) return;
      this.#img = img;
      this.#abort = new AbortController();
      const { signal } = this.#abort;

      this.#lead = {
        img: this.dataset.img || img.getAttribute('src') || '',
        srcset: this.dataset.srcset || img.getAttribute('srcset') || '',
        alt: img.alt || '',
      };
      this.#want = this.#lead.img;

      const card = this.closest('.cg-cgrid__card') || this;

      // The big stretched card link. On select we repoint it at the chosen
      // variant so tapping the main image opens that variant's PDP.
      this.#cardLink = card.querySelector('.cg-cgrid__card-link');
      this.#leadHref = this.#cardLink ? this.#cardLink.getAttribute('href') || '' : '';
      this.#transitionSource = this.querySelector('[ref="cardGallery"][data-view-transition-to-main-product]');

      card.addEventListener(
        'pointerleave',
        () => {
          if (hoverQuery.matches) this.#reset();
        },
        { signal },
      );
      // Keyboard focus-out reset (pointer devices only). On touch the selection
      // persists, so this stays gated to avoid resetting the card link href
      // right before a tap on the main image navigates it.
      card.addEventListener(
        'focusout',
        (event) => {
          if (!hoverQuery.matches) return;
          if (event.relatedTarget && card.contains(event.relatedTarget)) return;
          this.#reset();
        },
        { signal },
      );

      // Delegate thumbnail interactions once per gallery. A collection page can
      // render dozens of cards with several variant thumbnails each, so binding
      // three listeners per thumbnail creates avoidable listener churn during
      // the custom-element upgrade burst and every pagination morph.
      this.addEventListener(
        'pointerover',
        (event) => {
          if (!hoverQuery.matches) return;
          const thumb = this.#thumbFromEvent(event);
          if (!thumb) return;
          if (event.relatedTarget instanceof Node && thumb.contains(event.relatedTarget)) return;
          this.#select(thumb, false);
        },
        { signal },
      );
      this.addEventListener(
        'focusin',
        (event) => {
          if (!hoverQuery.matches) return;
          const thumb = this.#thumbFromEvent(event);
          if (thumb) this.#select(thumb, false);
        },
        { signal },
      );
      this.addEventListener(
        'click',
        (event) => {
          const thumb = this.#thumbFromEvent(event);
          if (!thumb) return;
          if (hoverQuery.matches) {
            if (thumb.getAttribute('href') !== this.#leadHref) {
              this.#transitionSource?.removeAttribute('data-view-transition-to-main-product');
            }
            return;
          }
          // Touch: tap previews in the main image + persists the selection
          // (current state + card link), and does NOT navigate to the PDP.
          event.preventDefault();
          this.#select(thumb, true);
        },
        { signal },
      );

      this.#bindThumbNav(signal);
    }

    disconnectedCallback() {
      this.#abort?.abort();
      this.#abort = null;
      this.#resize?.disconnect();
      this.#resize = null;
      // Drop the paddle record from the shared batch: a card removed by a
      // pagination morph between schedule and flush must not be measured.
      if (this.#nav) pendingNav.delete(this.#nav);
      this.#nav = null;
      this.#token += 1;
      this.#img = null;
      this.#lead = null;
      this.#want = '';
      this.#cardLink = null;
      this.#leadHref = '';
      this.#transitionSource = null;
    }

    // Prev / next paddles for the thumbnail strip.
    #bindThumbNav(signal) {
      const strip = this.querySelector('.cg-cgrid__thumbs');
      if (!strip) return;
      const track = strip.querySelector('[data-cg-thumbs-track]');
      const prev = strip.querySelector('[data-cg-thumbs-prev]');
      const next = strip.querySelector('[data-cg-thumbs-next]');
      if (!track || !prev || !next) return;

      // Live query read at click time, so an OS reduced-motion toggle takes
      // effect without re-rendering the section.
      const behavior = () => (reducedQuery.matches ? 'auto' : 'smooth');

      // `overflowing` starts undefined so the first flush always writes.
      const nav = { track, strip, prev, next, overflowing: undefined };
      this.#nav = nav;
      const update = () => scheduleNav(nav);
      const step = () => Math.max(track.clientWidth * 0.8, 96);

      prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: behavior() }), { signal });
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: behavior() }), {
        signal,
      });
      track.addEventListener('scroll', update, { signal, passive: true });

      if (typeof ResizeObserver === 'function') {
        this.#resize = new ResizeObserver(update);
        this.#resize.observe(track);
      } else {
        window.addEventListener('resize', update, { signal });
      }
      update();
    }

    #thumbFromEvent(event) {
      if (!(event.target instanceof Element)) return null;
      const thumb = event.target.closest('[data-cg-thumb]');
      return thumb && this.contains(thumb) ? thumb : null;
    }

    // persist=true (touch tap): mark the thumb current + repoint the card link
    // and keep it. persist=false (desktop hover/focus): transient preview, the
    // card link still follows so a card click opens the previewed variant.
    #select(thumb, persist) {
      this.#setLink(thumb.getAttribute('href') || this.#leadHref);
      if (persist) this.#setCurrent(thumb);
      const src = thumb.dataset.img || '';
      if (!src) return;
      this.#show(src, thumb.dataset.srcset || '', thumb.dataset.alt || '');
    }

    #reset() {
      this.#setLink(this.#leadHref);
      this.#show(this.#lead.img, this.#lead.srcset, this.#lead.alt);
    }

    #setLink(href) {
      if (this.#cardLink && href) this.#cardLink.setAttribute('href', href);
    }

    #setCurrent(thumb) {
      for (const t of this.querySelectorAll('[data-cg-thumb]')) {
        t.classList.remove('cg-cgrid__thumb--current');
        t.removeAttribute('aria-current');
      }
      thumb.classList.add('cg-cgrid__thumb--current');
      thumb.setAttribute('aria-current', 'true');
    }

    async #show(src, srcset, alt) {
      if (!src || this.#want === src) return;
      this.#transitionSource?.removeAttribute('data-view-transition-to-main-product');
      this.#want = src;
      const token = ++this.#token;
      const img = this.#img;
      const pre = new Image();
      if (srcset) {
        pre.sizes = img.getAttribute('sizes') || '';
        pre.srcset = srcset;
      }
      pre.src = src;
      try {
        await pre.decode();
      } catch {
        // decode can reject (eg evicted cache entry); swap anyway and let the
        // browser paint progressively
      }
      if (token !== this.#token || !this.isConnected) return;
      if (srcset) {
        img.srcset = srcset;
      } else {
        img.removeAttribute('srcset');
      }
      img.src = src;
      img.alt = alt || '';
      if (src === this.#lead.img && this.#cardLink?.getAttribute('href') === this.#leadHref) {
        this.#transitionSource?.setAttribute('data-view-transition-to-main-product', '');
      }
    }
  }

  if (!customElements.get('cg-cgrid-gallery')) {
    customElements.define('cg-cgrid-gallery', CgCgridGallery);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cg-contact-form-enhance"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.CGFormEnhance) {
      window.CGFormEnhance.bind(document);
      return;
    }

    // Long enough that a slow-but-real navigation is never interrupted, short
    // enough that a wedged form recovers before the visitor gives up.
    const RELEASE_MS = 8000;

    function stripEmptyOptional(form) {
      for (const el of form.querySelectorAll('[data-cg-optional]')) {
        if (el.type === 'checkbox' || el.type === 'radio') continue;
        const value = (el.value || '').trim();
        if (value === '' || (el.type === 'number' && Number(value) === 0)) {
          el.dataset.cgStripped = 'true';
          el.disabled = true;
        }
      }
    }

    function onSubmit(event) {
      const form = event.currentTarget;
      if (!(form instanceof HTMLFormElement)) return;

      const hp = form.querySelector('[data-cg-hp]');
      if (hp && hp.value.trim() !== '') {
        // Honeypot filled: drop the submission (almost certainly a bot).
        event.preventDefault();
        return;
      }
      if (form.dataset.cgSubmitting === 'true') {
        event.preventDefault();
        return;
      }
      form.dataset.cgSubmitting = 'true';
      stripEmptyOptional(form);
      const btn = form.querySelector('[type="submit"]');
      if (btn) {
        btn.dataset.cgBusy = 'true';
        btn.setAttribute('aria-busy', 'true');
      }
      // Detail: docs/comments/snippets/cg-contact-form-enhance.md#the-contact-post-is-a-full-navigation-so-the-happy-path-never-comes
      const release = setTimeout(restore, RELEASE_MS);
      window.addEventListener('pagehide', () => clearTimeout(release), { once: true });
    }

    function bind(scope) {
      for (const hp of (scope || document).querySelectorAll('[data-cg-hp]')) {
        const form = hp.closest('form');
        if (!form || form.dataset.cgEnhanced === 'true') continue;
        form.dataset.cgEnhanced = 'true';
        form.addEventListener('submit', onSubmit);
      }
    }

    function restore() {
      // Back/forward cache can restore a mid-submit form; release the lock.
      for (const btn of document.querySelectorAll('[data-cg-busy]')) {
        delete btn.dataset.cgBusy;
        btn.removeAttribute('aria-busy');
      }
      for (const form of document.querySelectorAll('form[data-cg-submitting]')) {
        delete form.dataset.cgSubmitting;
      }
      for (const el of document.querySelectorAll('[data-cg-stripped]')) {
        delete el.dataset.cgStripped;
        el.disabled = false;
      }
    }

    document.addEventListener('shopify:section:load', (event) => {
      bind(event.target);
    });
    window.addEventListener('pageshow', restore);
    window.CGFormEnhance = { bind };

    if (document.readyState !== 'loading') {
      bind(document);
    } else {
      document.addEventListener('DOMContentLoaded', () => {
        bind(document);
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cg-head"] && !Shopify.designMode) return;
  try {
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  class CgHead extends HTMLElement {
    #wired = false;
    #anims = [];
    #timers = [];
    #io = null;

    connectedCallback() {
      if (window.Shopify?.designMode || document.documentElement.classList.contains('shopify-design-mode')) {
        this.#wired = true;
        this.#io?.disconnect();
        this.#io = null;
        this.#clearAnimations();
        this.#snap();
        return;
      }

      if (this.#wired || this.getAttribute('data-cg-head-state') === 'ready') return;
      this.#wired = true;

      // Reveal when scrolled into view (above-fold fires ~immediately because
      // the element already intersects). Falls back to immediate reveal where
      // IntersectionObserver is unavailable.
      if (typeof IntersectionObserver !== 'function') {
        this.#reveal();
        return;
      }
      this.#io = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            this.#io.disconnect();
            this.#io = null;
            this.#reveal();
          }
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0.1 },
      );
      this.#io.observe(this);
    }

    disconnectedCallback() {
      this.#wired = false;
      if (this.#io) {
        this.#io.disconnect();
        this.#io = null;
      }
      this.#clearAnimations();
    }

    #clearAnimations() {
      this.#anims.forEach((anim) => anim.cancel());
      this.#timers.forEach(clearTimeout);
      this.#anims = [];
      this.#timers = [];
    }

    #watch(anim, timeout) {
      if (!anim) return;
      const timer = setTimeout(() => {
        if (anim.playState !== 'finished') anim.cancel();
      }, timeout);
      this.#timers.push(timer);
      if (anim.finished && typeof anim.finished.then === 'function') {
        anim.finished.then(
          () => clearTimeout(timer),
          () => clearTimeout(timer),
        );
      }
    }

    #revealOrder() {
      const ordered = [];
      const eyebrow = this.querySelector('[data-cg-anim="eyebrow"]');
      if (eyebrow) ordered.push({ el: eyebrow, y: 12 });
      const title = this.querySelector('[data-cg-anim="title"]');
      if (title) ordered.push({ el: title, y: 18 });
      else this.querySelectorAll('.cg-head__word').forEach((w) => ordered.push({ el: w, y: 18 }));
      return ordered;
    }

    #setReady() {
      this.dataset.cgHeadSeen = 'true';
      this.setAttribute('data-cg-head-state', 'ready');
    }

    #setWordsSettled() {
      this.setAttribute('data-cg-head-words', 'settled');
    }

    #snap() {
      this.querySelectorAll('[data-cg-anim], .cg-head__word').forEach((el) => {
        el.style.opacity = '';
        el.style.transform = '';
      });
      this.#setReady();
      this.#setWordsSettled();
    }

    #reveal() {
      if (this.getAttribute('data-cg-head-state') === 'ready') return;
      const ordered = this.#revealOrder();
      if (!ordered.length || typeof Element.prototype.animate !== 'function') {
        this.#snap();
        return;
      }

      const reduced = reducedMotionQuery.matches;
      const ease = 'cubic-bezier(0.22, 1, 0.36, 1)';
      this.#clearAnimations();
      let lastAnim = null;

      ordered.forEach((item, i) => {
        // Words descend (y -> 0); eyebrow leads. Audit opt-in contract for
        // reduced motion: opacity only, 160ms, NO stagger and no transform.
        const delay = reduced ? 0 : 180 + i * 60;
        const duration = reduced ? 160 : 600;
        const from = reduced ? { opacity: 0 } : { opacity: 0, transform: 'translateY(-' + item.y + 'px)' };
        const to = reduced ? { opacity: 1 } : { opacity: 1, transform: 'translateY(0)' };
        // fill:backwards holds the hidden start through the stagger delay, so
        // flipping the pending state to ready below does not flash the words at
        // full opacity before each fade begins.
        const anim = item.el.animate([from, to], {
          duration: duration,
          delay: delay,
          easing: reduced ? 'ease-out' : ease,
          fill: 'backwards',
        });
        this.#anims.push(anim);
        this.#watch(anim, delay + duration + 400);
        lastAnim = anim;
      });

      // Rejoin the per-word boxes into one text run once the last word lands.
      // Both settle paths matter: a clean finish and the #watch cancel, which
      // rejects `finished`.
      if (lastAnim && lastAnim.finished && typeof lastAnim.finished.then === 'function') {
        const settle = () => this.#setWordsSettled();
        lastAnim.finished.then(settle, settle);
      } else {
        this.#setWordsSettled();
      }

      // Drop the pending hide (resting state becomes visible once the tweens end,
      // since forwards fill stays none) and trigger the accent-rule draw.
      this.#setReady();
    }
  }

  if (!customElements.get('cg-head')) {
    customElements.define('cg-head', CgHead);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["slideshow-controls"] && !Shopify.designMode) return;
  try {
    // Detail: docs/comments/snippets/slideshow-controls.md#prevnext-scroll-paddles-for-the-pdp-thumbnail-strip

  // cg: one MediaQueryList per page, not one per instance, and READ LIVE at click
  // time. This block has its own function scope and evaluates once per page
  // (Contract 20), so block top level is the per-page singleton slot. The previous
  // shape opened a query inside connectedCallback and snapshotted `.matches` into a
  // `behavior` const, so N thumbnail strips held N live MediaQueryLists on the same
  // breakpoint AND a mid-session OS reduced-motion toggle was never honored: the
  // strip kept smooth-scrolling for the rest of the session. Mirrors
  // snippets/cg-cgrid-gallery-js.liquid, which is the already-migrated twin of this file.
  const thumbReducedQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  // cg: shared read-then-write scheduler. `update` previously read scrollWidth and
  // clientWidth, wrote an attribute, then read scrollLeft again, all synchronously,
  // bound straight to a scroll listener with no rAF and used directly as the
  // ResizeObserver callback so an attribute write could re-enter through the observer.
  // Batching splits the passes and suppresses no-op writes, so a steady-state scroll
  // invalidates nothing. Same shape and same rationale as cg-cgrid-gallery-js.liquid.
  const pendingThumbNav = new Set();
  let thumbNavFrame = 0;

  const flushThumbNav = () => {
    thumbNavFrame = 0;
    const batch = [...pendingThumbNav];
    pendingThumbNav.clear();

    // Read pass: no writes in this loop, or the next read re-lays out.
    const measured = [];
    for (const nav of batch) {
      if (!nav.track.isConnected) continue;
      measured.push({
        nav,
        max: Math.max(nav.track.scrollWidth - nav.track.clientWidth, 0),
        left: nav.track.scrollLeft,
      });
    }

    // Write pass.
    for (const { nav, max, left } of measured) {
      const overflowing = max > 1;
      if (overflowing !== nav.overflowing) {
        nav.overflowing = overflowing;
        nav.host.toggleAttribute('data-overflowing', overflowing);
      }
      const atStart = left <= 1;
      const atEnd = left >= max - 1;
      if (nav.prev.disabled !== atStart) nav.prev.disabled = atStart;
      if (nav.next.disabled !== atEnd) nav.next.disabled = atEnd;
    }
  };

  const scheduleThumbNav = (nav) => {
    pendingThumbNav.add(nav);
    if (thumbNavFrame) return;
    thumbNavFrame = requestAnimationFrame(flushThumbNav);
  };

  class SlideshowThumbnailPaddles extends HTMLElement {
    #controller = null;
    #resize = null;
    #nav = null;

    connectedCallback() {
      const track = this.querySelector('[data-thumb-track]');
      const prev = this.querySelector('[data-thumb-paddle="prev"]');
      const next = this.querySelector('[data-thumb-paddle="next"]');
      if (!track || !prev || !next) return;

      // `overflowing` starts undefined so the first flush always writes, whatever
      // the server-rendered attribute said.
      this.#nav = { host: this, track, prev, next, overflowing: undefined };
      const update = () => scheduleThumbNav(this.#nav);
      const step = () => Math.max(track.clientWidth * 0.8, 96);
      const scrollByStep = (direction) =>
        track.scrollBy({
          left: direction * step(),
          behavior: thumbReducedQuery.matches ? 'auto' : 'smooth',
        });

      this.#controller = new AbortController();
      const { signal } = this.#controller;

      prev.addEventListener('click', () => scrollByStep(-1), { signal });
      next.addEventListener('click', () => scrollByStep(1), { signal });
      track.addEventListener('scroll', update, { signal, passive: true });

      if (typeof ResizeObserver === 'function') {
        this.#resize = new ResizeObserver(update);
        this.#resize.observe(track);
      } else {
        window.addEventListener('resize', update, { signal });
      }
      update();
    }

    disconnectedCallback() {
      this.#controller?.abort();
      this.#controller = null;
      this.#resize?.disconnect();
      this.#resize = null;
      // Drop the record or the shared scheduler retains a removed subtree.
      if (this.#nav) pendingThumbNav.delete(this.#nav);
      this.#nav = null;
    }
  }

  if (!customElements.get('slideshow-thumbnail-paddles')) {
    customElements.define('slideshow-thumbnail-paddles', SlideshowThumbnailPaddles);
  }
  } catch(e) { console.error(e); }
})();

})();
